<template>
  <el-footer class="site-footer" height="auto">
    <div class="footer-content">
      <el-row :gutter="40">
        <!-- 关于我们 -->
        <el-col :xs="24" :sm="8" class="footer-col">
          <h4>关于学会</h4>
          <p>我们致力于推进首都地区生物工程与技术产业的发展以及学术气氛的活跃，加速研究成果转化和产业化，促进首都地区的经济与社会的发展。</p>
        </el-col>

        <!-- 联系方式 -->
        <el-col :xs="24" :sm="8" class="footer-col">
          <h4>联系我们</h4>
          <ul class="contact-list">
            <li><i class="el-icon-location-outline"></i> 地址：北京市朝阳区安翔北里11号5层501室</li>
            <li><i class="el-icon-phone-outline"></i> 电话：13611023060</li>
            <li><i class="el-icon-message"></i> 邮箱：zhurongrong@bsbt.org.cn</li>
          </ul>
        </el-col>

        <!-- Logo和备案信息 -->
        <el-col :xs="24" :sm="8" class="footer-col">
          <div class="logo-section">
            <img src="/logo.jpg" alt="Logo" class="footer-logo" />
          </div>
          <div class="icp-info">
            <p>京ICP备2025141957号-1</p>
            <div class="gongan-info">
              <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502057559" rel="noreferrer" target="_blank">
                <img src="/gongan.png" alt="公安备案" class="gongan-icon" />
                京公网安备11010502057559号
              </a>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 版权信息 -->
      <el-divider></el-divider>
      <div class="copyright-info">
        <span>© 北京生物工程学会 版权所有</span>
      </div>
    </div>
  </el-footer>
</template>

<script>
export default {
  name: 'Footer',
};
</script>

<style scoped>
.site-footer {
  background-color: #303133;
  color: #c0c4cc;
  padding: 40px 0;
  margin-top: 30px;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-col h4 {
  font-size: 16px;
  color: #ffffff;
  margin-bottom: 20px;
  font-weight: 500;
}

.footer-col p {
  font-size: 14px;
  line-height: 1.8;
}

.contact-list {
  list-style: none;
  padding: 0;
  margin: 0;
  font-size: 14px;
}

.contact-list li {
  margin-bottom: 12px;
  display: flex;
  align-items: center;
}

.contact-list i {
  margin-right: 10px;
  font-size: 16px;
}

.footer-col {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.logo-section {
  text-align: center;
  margin-bottom: 15px;
  margin-top: 40px;
}

.footer-logo {
  max-width: 80px;
  max-height: 60px;
  object-fit: contain;
}

.icp-info {
  text-align: center;
}

.icp-info p {
  margin: 0;
  color: #ccc;
  font-size: 12px;
}

.gongan-info {
  margin-top: 8px;
  text-align: center;
}

.gongan-info a {
  color: #ccc;
  text-decoration: none;
  font-size: 12px;
  display: inline-flex;
  align-items: center;
  transition: color 0.3s;
}

.gongan-info a:hover {
  color: #409eff;
}

.gongan-icon {
  width: 14px;
  height: 14px;
  margin-right: 4px;
  vertical-align: middle;
}

.copyright-info {
  text-align: center;
  padding-top: 20px;
  font-size: 13px;
}

@media (max-width: 768px) {
  .footer-col {
    text-align: center;
    margin-bottom: 30px;
  }
}
</style>
